'use client';

import React, { createContext, useContext, useState } from 'react';

const EstimatorContext = createContext();

export const useEstimator = () => useContext(EstimatorContext);

const initialFormData = {
  estimateId: null,
  projectInfo: {
    date: '',
    estimatedBy: '',
    requestedBy: '',
    projectName: '',
    projectScope: '',
  },
  quantities: [],
  rowCalculator: [],
  pipeSpecs: [],
  costAssumptions: [],
  specialItems: [],
  costCategory: [],

  overrideCost: '',
  averageROWCostPerFoot: null,
  averageROWCostPerRod: null,
  totalPercentOfRoute: null,

  hiddenPipeCostCalc: {},
};

export const EstimatorProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialFormData);

  const clearFormData = () => setFormData(initialFormData);

  return (
    <EstimatorContext.Provider value={{ formData, setFormData, clearFormData }}>{children}</EstimatorContext.Provider>
  );
};
